import * as React from 'react'
import { OppCardsProviderProps } from '../typings'
import { getStyles } from './useStyles'
import { NoResultsCard, Pagination } from '@sales-center/components'
import { OpportunityCard } from '../OpportunityCard'
import { IOpportunity } from '@user/store/opportunity/typings'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { EntityAppointmentMap } from '@user/store/scheduling/hooks/useGetEntitiesWithAppointment'
import { useTheme } from '@mui/material/styles'

export type OppCardsProps = Omit<OppCardsProviderProps, 'loading'> & {
  opps: IOpportunity[]
  onChangePage: (event: React.ChangeEvent<unknown>, newPage: number) => void
  appointmentsMap: EntityAppointmentMap
}

export function OpportunityCards(props: OppCardsProps) {
  const { opps, appointmentsMap, ...rest } = props
  const styles = getStyles(useTheme())
  return (
    <Box sx={styles.listWrapper}>
      <Grid container>
        <Grid item xs>
          {opps.length == 0 ? (
            <NoResultsCard label="No Opportunities found" />
          ) : (
            <>
              {opps.map((o) => (
                <OpportunityCard
                  {...rest}
                  key={o.id}
                  opportunity={o}
                  hasScheduledAppointment={appointmentsMap.get(o.id) ?? false}
                />
              ))}
            </>
          )}
        </Grid>
      </Grid>
      <Box display="flex" justifyContent="flex-end" mt={1} mb={0.5}>
        <Pagination {...rest} />
      </Box>
    </Box>
  )
}
